import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { db } from './firebase';
import { doc, setDoc, serverTimestamp } from 'firebase/firestore';
import app from './firebase';

// Your VAPID key from Firebase Console → Project Settings → Cloud Messaging
const VAPID_KEY = 'YOUR_VAPID_KEY_FROM_FIREBASE_CONSOLE';

let messaging = null;

function getMessagingInstance() {
  if (!messaging) {
    try {
      messaging = getMessaging(app);
    } catch (e) {
      console.warn('Firebase messaging not supported in this browser.');
    }
  }
  return messaging;
}

// Request permission and get FCM token
export async function requestNotificationPermission(userId, userEmail) {
  if (!('Notification' in window)) return null;
  if (!('serviceWorker' in navigator)) return null;

  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return null;

    const msg = getMessagingInstance();
    if (!msg) return null;

    const token = await getToken(msg, { vapidKey: VAPID_KEY });

    if (token) {
      // Store token in Firestore so Cloud Functions can send to this device
      await setDoc(doc(db, 'fcmTokens', token), {
        token,
        userId: userId || null,
        email: userEmail || null,
        role: userEmail === 'dezamaxo@gmail.com' ? 'admin' : 'client',
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });
    }

    return token;
  } catch (err) {
    console.warn('Could not get notification token:', err);
    return null;
  }
}

// Listen for foreground messages (app is open)
export function listenForForegroundMessages(onReceive) {
  const msg = getMessagingInstance();
  if (!msg) return () => {};

  return onMessage(msg, (payload) => {
    onReceive(payload);
  });
}

// Show an in-app toast notification
export function showToast(title, body, actionUrl) {
  const existing = document.getElementById('ld-toast');
  if (existing) existing.remove();

  const toast = document.createElement('div');
  toast.id = 'ld-toast';
  toast.style.cssText = `
    position: fixed; top: 16px; left: 50%; transform: translateX(-50%);
    background: #1B4F2A; color: white; border-radius: 12px;
    padding: 14px 20px; max-width: 340px; width: calc(100% - 32px);
    box-shadow: 0 4px 24px rgba(0,0,0,0.25); z-index: 9999;
    display: flex; align-items: flex-start; gap: 12px;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, sans-serif;
    animation: slideDown 0.3s ease;
  `;

  toast.innerHTML = `
    <style>@keyframes slideDown { from { opacity:0; transform: translateX(-50%) translateY(-20px); } to { opacity:1; transform: translateX(-50%) translateY(0); } }</style>
    <div style="font-size:20px">🌿</div>
    <div style="flex:1">
      <div style="font-weight:700; font-size:0.9rem; margin-bottom:2px">${title}</div>
      <div style="font-size:0.8rem; opacity:0.85">${body}</div>
    </div>
    <button onclick="this.parentElement.remove()" style="background:none;border:none;color:white;opacity:0.7;cursor:pointer;font-size:1.1rem;padding:0;width:auto">×</button>
  `;

  if (actionUrl) {
    toast.style.cursor = 'pointer';
    toast.addEventListener('click', (e) => {
      if (e.target.tagName !== 'BUTTON') {
        window.location.href = actionUrl;
        toast.remove();
      }
    });
  }

  document.body.appendChild(toast);
  setTimeout(() => toast?.remove(), 6000);
}
